// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2d9I1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2A3ag"};